import React from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton, DateField } from '@refinedev/antd';
import { Table, Space, Tag, Grid } from 'antd';
import { IResourceComponentsProps, BaseRecord } from '@refinedev/core';

const { useBreakpoint } = Grid;

export const OfferList: React.FC<IResourceComponentsProps> = () => {
  const screens = useBreakpoint();
  const { tableProps } = useTable({
    syncWithLocation: true,
  });

  return (
    <List>
      <Table
        {...tableProps}
        rowKey="id"
        scroll={{ x: 800 }}
        size={screens.xs ? 'small' : 'middle'}
        locale={{
          emptyText: (
            <div style={{ padding: 24, textAlign: 'center' }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>🎁</div>
              <div style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 4 }}>
                No Offers Found
              </div>
              <div style={{ color: '#888', marginBottom: 16 }}>
                Create special offers to boost engagement and sales.
              </div>
            </div>
          ),
        }}
      >
        <Table.Column dataIndex="name" title="Name" width={150} ellipsis />
        <Table.Column
          dataIndex="type"
          title="Type"
          width={100}
          render={(value) => <Tag>{value}</Tag>}
        />
        <Table.Column
          dataIndex="platform"
          title="Platform"
          width={100}
          responsive={['md']}
          render={(value) => <Tag color="blue">{value}</Tag>}
        />
        <Table.Column
          dataIndex="isActive"
          title="Status"
          width={90}
          render={(value) => (
            <Tag color={value ? 'green' : 'red'}>{value ? 'Active' : 'Inactive'}</Tag>
          )}
        />
        <Table.Column dataIndex="priority" title="Priority" width={80} responsive={['lg']} />
        <Table.Column
          dataIndex="startDate"
          title="Start"
          width={100}
          responsive={['md']}
          render={(value) => (
            <DateField value={value} format={screens.xs ? 'MM/DD' : 'YYYY-MM-DD'} />
          )}
        />
        <Table.Column
          dataIndex="endDate"
          title="End"
          width={100}
          responsive={['sm']}
          render={(value) => (
            <DateField value={value} format={screens.xs ? 'MM/DD' : 'YYYY-MM-DD'} />
          )}
        />
        <Table.Column
          title=""
          dataIndex="actions"
          width={100}
          fixed="right"
          render={(_, record: BaseRecord) => (
            <Space size={4}>
              <EditButton hideText size="small" recordItemId={record.id} />
              <ShowButton hideText size="small" recordItemId={record.id} />
              {screens.sm && <DeleteButton hideText size="small" recordItemId={record.id} />}
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
